import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Button,
  IconButton
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import CardFormFields from './CardFormFields';
import CardBrandSelector from './CardBrandSelector';

const AddCardModal = ({
  isOpen,
  onClose,
  cardData,
  formErrors,
  onInputChange,
  onBrandSelect,
  onSubmit,
  isLoading,
  isCvvFocused,
  setIsCvvFocused
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2
        }
      }}
    >
      <DialogTitle sx={{ pb: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{ color: '#6B46C1', fontWeight: 'bold' }}>
             Adicionar novo cartão
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ color: '#666' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <CardFormFields
          cardData={cardData}
          errors={formErrors}
          onInputChange={onInputChange}
          isCvvFocused={isCvvFocused}
          setIsCvvFocused={setIsCvvFocused}
        />

        {/* Bandeira do Cartão */}
        <Box sx={{ mt: 3 }}>
          <CardBrandSelector
            selectedFlag={cardData.flag}
            onSelectBrand={onBrandSelect}
            error={formErrors.bandeira}
          />
        </Box>

        <Box display="flex" justifyContent="center" gap={2} mt={4}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              color: '#6B46C1',
              borderColor: '#6B46C1',
              borderRadius: 25,
              px: 4,
              py: 1.5,
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#f3f0ff',
                borderColor: '#6B46C1'
              }
            }}
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={isLoading}
            sx={{
              backgroundColor: '#6B46C1',
              color: 'white',
              borderRadius: 25,
              px: 4,
              py: 1.5,
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#553C9A'
              }
            }}
          >
            {isLoading ? 'Processando...' : 'Continue para atualizar'}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddCardModal;